module.exports = __webpack_public_path__ + "static/media/6.2a0bdb3a.jpg";